<template>
  <div
    :class="[
      'profile',
      {
        selecteble,
        active: isActive,
        info__block: !profilePopUpType && isActive,
      },
    ]"
    @click="toggle"
    tabindex="-1"
    @blur="handleBlur"
    :style="downloadable ? 'max-width:100%' : null"
  >
    <!-- Профайл -->
    <div class="profile__row" :style="orderProfileRowStyle">
      <div class="profile__row" :style="orderProfileRowStyle">
        <img
          v-if="user.avatar"
          class="profile__img"
          :src="require(`@/assets/img/${user.avatar}`)"
          alt="usurname"
        />
        <div
          v-else
          class="profile__avatar"
          :style="`background: ${userAvatarColor(user.roles)}`"
        >
          <div class="avatar__cover" />
          <span>{{ userAcronym(user) }}</span>
        </div>

        <div class="profile__right">
          <p v-if="!fullUserinfo" class="profile__name">
            {{
              (!user.name && !user.surname
                ? "Пользователь"
                : `${user.surname || ""} ${user.name || ""} ${
                    user.patronymic || ""
                  }`)
            }}
          </p>
          <div :class="returnUser ? 'profile__right-row' : 'profile__right-col'" v-else>
            <p>{{ user.surname }}</p>
            <p>{{ user.name }}</p>
            <p>{{ user.patronymic }}</p>
          </div>
          <small class="profile__info" v-if="!shortUserinfo">{{ userDepartment }}</small>
          <small class="profile__info" v-if="!shortUserinfo">{{ userFiliation }}</small>
        </div>
      </div>
      <svgicon
          v-if="selecteble "
          :class="['profile__action', { active: isActive }]"
          icon="arrow"
          width="18px"
      />
    </div>

    <!-- Загрузка файла -->
    <!-- <input
      hidden
      ref="file"
      @change="handleUpload"
      type="file"
      :accept="acceptFile"
    />
    <Button
      v-if="downloadable && !file"
      @click="$refs.file.click()"
      icon="attach"
      iconWidth="14px"
      class="btn-secondary upload__file"
      width="129px"
      height="32px"
      text="Прикрепить"
    />
    <VFile
      v-if="downloadable"
      v-model="file"
      removable
      @remove="removeFile"
      style="margin: 20px 0 0 10px"
    /> -->

    <!-- Список events -->
    <transition name="fade">
      <ul class="profile__menu" v-if="isActive && profilePopUpType">
        <li
          v-for="event in events"
          class="profile__link"
          :key="event.title"
          @click="event.event"
        >
          <svgicon
            :icon="event.icon"
            width="12"
            class="icon-link"
            color="#0071B3"
          />{{ event.title }}
        </li>
      </ul>
    </transition>

    <!-- user info -->
    <div v-if="isActive && !profilePopUpType">
      <h2 v-if="user.phone" class="profile__phone">
        {{ user.phone | phone }}
      </h2>
      <VFile :value="user.ticket" style="margin-top: 16px" />

      <div v-for="(passenger, i) in passengers" :key="'pas' + i">
        <hr v-if="passenger" />

        <div v-if="passenger" class="profile__row" style="margin-top: 8px">
          <img
            v-if="passenger.avatar"
            class="profile__img"
            :src="require(`@/assets/img/${passenger.avatar}`)"
            alt="usurname"
          />
          <div v-else class="profile__avatar">
            <div class="avatar__cover" />
            <span>{{ userAcronym(passenger) }}</span>
          </div>

          <div class="profile__right">
            <p class="profile__name">
              {{ passenger.name }} {{ passenger.surname }} {{ passenger.patronymic }}
            </p>
            <small class="profile__info">{{ "" }}</small>
          </div>
        </div>

        <VFile
          v-if="passenger"
          :value="passenger.ticket"
          style="margin-top: 16px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VFile from "@/components/VFile";
// import Button from "@/components/Button.vue";
import { removeFile } from "@/api/files";
import { mapGetters } from "vuex";

export default {
  components: {
    VFile,
    // Button,
  },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    selecteble: {
      type: Boolean,
      default: false,
    },
    downloadable: {
      type: Boolean,
      default: false,
    },
    acceptFile: {
      type: String,
      default: null,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    fullUserinfo: {
      type: Boolean,
      default: false,
    },
    shortUserinfo: {
      type: Boolean,
      default: false,
    },
    returnUser: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isActive: false,
      file: this.user.ticket || null,
    };
  },
  methods: {
    toggle() {
      if (this.selecteble) {
        this.isActive = !this.isActive;
      }
    },
    userAcronym(user) {
      if (user?.name && user?.surname) {
        return (user.name[0] + user.surname[0]).toUpperCase();
      } else if (user?.name) {
        return user.name[0].toUpperCase();
      } else return "ПП";
    },
    handleBlur() {
      if (this.profilePopUpType) this.isActive = false;
    },
    // handleUpload(evt) {
    //   this.file = evt.target.files[0];
    //   this.$emit("upload", this.file);
    // },
    async removeFile() {
      await removeFile(this.user.ticket?.id);
      this.user.ticket = null;
    },
  },
  computed: {
    ...mapGetters("departments", ["getDepartmentNameById"]),
    ...mapGetters("filiations", ["getFiliationNameById"]),
    ...mapGetters("users", ["userAvatarColor"]),
    passengers() {
      return this.user.passengers || [];
    },
    userDepartment() {
      return (
        this.user?.department?.name ||
        this.getDepartmentNameById(this.user?.department_id)
      );
    },
    userFiliation() {
      return (
        this.user?.filiation?.name ||
        this.getFiliationNameById(this.user?.department_id)
      );
    },
    orderProfileRowStyle() {
      return !this.profilePopUpType && this.fullUserinfo
        ? "align-items: start; width:100%"
        : null;
    },
    profilePopUpType() {
      return !!this.events.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  position: relative;
  border-radius: 100px;
  transition: all 0.3s;
  padding: 4px;
  width: 100%;
  margin-top: 0 !important;

  &.info__block {
    border-radius: 0;
    overflow: hidden;
    width: 100%;
    animation: showing 1s;

    @keyframes showing {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    hr {
      margin: 16px -15px 10px;
    }
  }

  &.selecteble {
    cursor: pointer;
  }

  .profile__row {
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .profile__img {
    border-radius: 50%;
    margin-left: 4px;
  }
  .profile__name {
    display: inline;
    width: fit-content;
    font-size: 16px;
    line-height: 100%;
    color: $black;
    font-weight: 500;
  }
  .profile__info {
    font-size: 12px;
    margin-top: 6px;
    line-height: 100%;
    color: #97B2C4;
    font-weight: 300;
    word-break: break-word;
  }
  .profile__right {
    display: flex;
    flex-direction: column;
    margin-left: 14px;
    text-align: left;
    width: 95%;
    margin-right: 12px;
    padding: 12px 0;

    .profile__right-col {
      display: flex;
      flex-direction: column;
    }

    .profile__right-row {
      display: flex;
      flex-direction: row;

      p {
        margin-right: 6px;
      }
    }
  }
  .profile__action {
    transition: 0.2s;
    fill: rgba(0, 57, 92, 0.8);
    //margin: auto -3px 12px 11px;

    &.active {
      transform: rotate(180deg);
    }
  }

  .profile__avatar {
    background: $blue-user;
    border-radius: 100%;
    overflow: hidden;
    min-width: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    position: relative;

    span {
      font-weight: 600;
      font-size: 10px;
      line-height: 100%;
    }
  }
}

.profile__phone {
  line-height: 150%;
  margin-top: 8px;
}

.profile__menu {
  position: absolute;
  z-index: 999;
  top: 95%;
  min-width: 100%;
  white-space: nowrap;
  text-align: left;
  padding: 9px 0;
  background: #ffffff;
  border: 1px solid rgba(0, 65, 102, 0.2);
  box-shadow: 0 4px 4px rgba(0, 32, 51, 0.04), 0 8px 24px rgba(0, 32, 51, 0.12);
  border-radius: 4px;

  li {
    padding: 4px 12px;
    cursor: pointer;

    &:hover {
      background: rgba(0, 66, 105, 0.05);
    }
  }
  .profile__link {
    color: $black;
    font-size: 14px;
    line-height: 120%;

    .icon-link {
      margin-right: 8px;
    }
  }
}

.upload__file {
  position: absolute;
  font-size: 14px;
  right: 0;
  top: 0;
}

.user__item .profile__action {
  position: absolute;
  top: 75px;
  left: calc(100% - 18px);
}

.application .info .profile__avatar {
  margin-top: 12px
}

.return_pas .profile__avatar {
  margin-top: 12px
}

.accordion-order__user .profile__avatar {
  margin-top: 12px
}
</style>